// Which revision «До изменений» is taken from. Mirrors base_revision() in
// services/workbench/src/workbench/vor_template.py; the list comes ordered by creation time.

export type BaseCandidate = { id: string; name: string; kind: string; confirmed: boolean };

export function baseRevision<T extends BaseCandidate>(revisions: T[], currentId: string): { base: T | null; pending: string | null } {
  const index = revisions.findIndex(r => r.id === currentId);
  const current = revisions[index];
  if (!current || current.kind === "before") return { base: null, pending: null };
  const others = revisions.filter((r, i) => r.id !== currentId && (r.kind === "before" || i < index));
  const ranked = [...others.filter(r => r.kind === "before"), ...others.filter(r => r.kind !== "before")];
  const base = ranked.find(r => r.confirmed) ?? null;
  return { base, pending: base ? null : ranked.find(r => !r.confirmed)?.name ?? null };
}

export function baseText(revisions: BaseCandidate[], currentId: string): string {
  const { base, pending } = baseRevision(revisions, currentId);
  if (base) return `исходный объём по документам исходной редакции «${base.name}» до корректировок`;
  return "исходный объём по документу до корректировок"
    + (pending ? `; состав более ранней редакции «${pending}» не подтверждён, поэтому она не используется` : "");
}
